export default {"src":"/_next/static/media/ico_bar.57545cc0.svg","height":64,"width":42,"blurWidth":0,"blurHeight":0};